import { render, staticRenderFns } from "./CbsBudreqCell.vue?vue&type=template&id=332570d9&scoped=true"
import script from "./CbsBudreqCell.vue?vue&type=script&lang=js"
export * from "./CbsBudreqCell.vue?vue&type=script&lang=js"
import style0 from "./CbsBudreqCell.vue?vue&type=style&index=0&id=332570d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332570d9",
  null
  
)

export default component.exports